import { buildProps } from '@vuesax-plus/utils'

import type { ExtractPropTypes } from 'vue'
import type CardGroup from './card-group.vue'

export const cardGroupProps = buildProps({})

export type CardGroupProps = ExtractPropTypes<typeof cardGroupProps>
export type CardGroupInstance = InstanceType<typeof CardGroup>
